import React from 'react';
import styled from 'styled-components';

const Pattern = ({ children }: React.PropsWithChildren) => {
  return (
    <StyledWrapper>
      <div className="loginContainer" />
      <Content>{children}</Content>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: 0;
  background: linear-gradient(135deg, #ffe8f3, #d9f3ff);

  .loginContainer {
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    overflow: hidden;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.2),
      rgba(0, 0, 0, 0.1)
    );
    z-index: 1;
  }

  .loginContainer::before,
  .loginContainer::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200vw;
    height: 200vh;
    background: conic-gradient(
      from 0deg,
      #ff9aa2,
      #ffb7b2,
      #ffdac1,
      #e2f0cb,
      #a2e4ff,
      #c9afff,
      #ffb7b2,
      #ff9aa2
    );
    transform: translate(-50%, -50%);
    animation: rotate 8s linear infinite;
    filter: blur(50px);
    opacity: 0.8;
    z-index: 2;
  }

  .loginContainer::after {
    width: 180vw;
    height: 180vh;
    animation: rotate-reverse 10s linear infinite;
    opacity: 0.6;
  }

  @keyframes rotate {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  @keyframes rotate-reverse {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(-360deg);
    }
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Pattern; 